module.exports = {
  url: {
    api: `https://api.dfm-app.nl`,
    login: `https://{{domain}}.dfm-app.nl`,
    main: `https://{{domain}}.dfm-app.nl`,
    cdn: `https://cdn.dfm-app.nl`,
    admin: "https://inschrijvingsmanager.defittemedewerker.nl",
  },
  cookiedomain: "dfm-app.nl",
  base_domain: "dfm-app.nl",
  // Sidebar items and routes that need an integration hide when it is false (util/integrations.js).
  integrations: {
    flexwell: false,
    zoho: false,
  },

  rules: {
    required: [(v) => !!v || "Required field!"],
    name: [
      (v) => !!v || "Required field!",
      (value) => (value && !(value.length > 100)) || "Maximum 100 characters",
    ],
    email: [
      (v) => !!v || "Email address is not valid!",
      (v) => /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v) || "Invalid email address!",
    ],
    phonenumber: [
      (v) => !!v || "Phone number is not valid!",
      (v) =>
        /^[+]?[\s./0-9]*[(]?[0-9]{1,4}[)]?[-\s./0-9]*$/g.test(v) ||
        "Invalid phone number!",
    ],
  },
  regex: {
    name: /^[a-zA-Z -]{2,50}$/,
    mail: /^[^@\s]+@[^@\s]+\.[^@\s]+$/,
    phonenumber: /^\+?[1-9]\d{3,14}$/,
    password:
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!#%*?&])[A-Za-z\d@$!#%*?&]{8,64}$/,
  },
  dateformat: {
    weekday: "short",
    year: "numeric",
    day: "numeric",
    month: "long",
    hour: "numeric",
    minute: "numeric",
  },
};
